import type { ChallengeImages } from '@source/graphql/autogenerate/schemas';
import { useEffect, useState } from 'react';
import * as S from '../styles';

type Props = {
  slide: number;
  images: ChallengeImages[];
};

const CarouselDots: React.FC<Props> = ({ slide, images }): JSX.Element => {
  const [listOfDots, setListOfDots] = useState<Array<Array<string>>>();

  // index of the array inside the list of dots array dependent on the current slide
  const currentSlideSet = Math.floor(slide / 5);

  // current image position relative to the slide set
  const currentRelativePosition = slide - 5 * currentSlideSet;

  useEffect(() => {
    const calculatedDots: Array<Array<string>> = [] as Array<Array<string>>;

    images.map((image, index) => {
      const currentSet = Math.floor(index / 5);

      calculatedDots[currentSet]
        ? calculatedDots[currentSet].push(
            slide === index ? 'active' : 'inactive'
          )
        : calculatedDots.push([slide === index ? 'active' : 'inactive']);
    });

    setListOfDots(calculatedDots);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide]);

  if (
    !listOfDots ||
    (listOfDots[currentSlideSet] && listOfDots[currentSlideSet]?.length === 0)
  ) {
    return <></>;
  }

  return (
    <S.DotsWrapper>
      {listOfDots[currentSlideSet].map((dot, index) => (
        <S.Dot
          key={index}
          className={dot}
          // decreases the dot size according to the distance to the active dot
          size={Math.abs(1 - Math.abs(currentRelativePosition - index) / 10)}
        ></S.Dot>
      ))}
    </S.DotsWrapper>
  );
};

export default CarouselDots;
